import dayjs from 'dayjs'
import 'dayjs/locale/ru'

dayjs.locale('ru')

export const getDateTSFormat = (ts: number, format: string = "DD MMM YYYY, HH:mm") => {
  return dayjs(ts).format(format)
}